// Goal Digger Wear — Theme JS
document.addEventListener('DOMContentLoaded', function() {
  // Size selector
  document.querySelectorAll('.gd-size-btn input').forEach(function(radio) {
    radio.addEventListener('change', function() {
      document.querySelectorAll('.gd-size-btn').forEach(function(btn) { btn.classList.remove('gd-size-btn--active'); });
      this.closest('.gd-size-btn').classList.add('gd-size-btn--active');
    });
  });
});
